import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import useStyles from "./styles";
import { getContrastColor } from "~/utils/business";

const ScheduleHeader = ({ view, title, subtitle }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const colorBackgroundStorage = sessionStorage.getItem("@prit/colorBackground");
	const colorTextContrast = colorBackgroundStorage && getContrastColor(colorBackgroundStorage);

	const selectedView = () => {
		switch (view) {
			case "selectTime":
				return (
					<div className={classes.container}>
						<Typography 
							className={classes.title} 
							style={colorTextContrast ? { color: colorTextContrast } : undefined}
						>
							{title || t("Select time")}
						</Typography>
						<Typography className={classes.subtitle} 
							style={colorTextContrast ? { color: colorTextContrast } : undefined}
						>
							{subtitle}
						</Typography>
					</div>
				);
			case "selectDate":
				return (
					<div className={classes.container}>
						<Typography className={classes.title} style={colorTextContrast ? { color: colorTextContrast } : undefined}>
							{title || t("Select date")}
						</Typography>
						<Typography className={classes.subtitle} style={{ width: "80%", color: colorTextContrast ?? colorTextContrast }
					}>
							{subtitle}
						</Typography>
					</div>
				);
			default:
				return null;
		}
	};

	return <>{selectedView()}</>;
};

export default ScheduleHeader;
